export default __webpack_public_path__ + "assets/images/11503f38cae35cd67f67946991e37128.jpg";